import {secureProtocol} from '../constants/server/secure-protocol.constant';

export function extractHostname(url: string | undefined): string | undefined {
    if (!url) {
        return undefined;
    }
    if (URL.canParse(url)) {
        return new URL(url).hostname;
    }
    if (URL.canParse(secureProtocol + url)) {
        return new URL(secureProtocol + url).hostname;
    }
    return undefined;
}